<template>
  <el-dialog
    title="退款确认"
    :visible.sync="isShow"
    destroy-on-close
    width="800px"
    @close="closeDialog"
  >
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            电汇单号：
          </div>
          <div>{{ baseData.telegraphicTransferNum }}</div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.unusedAmount }}元
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            退款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.returnAmount }}元
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            收款单位：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.payee }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            银行账号：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.bankAccount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            开户行：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.openBank }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            客户联行号：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.customerBankNo }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            SWIFT CODE：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.swiftCode }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            申请原因：
          </div>
          <div class="rj-baseinfo__item">
            {{ baseData.reason }}
          </div>
        </div>
      </div>
    </div>

    <div class="rj-page-card__title" style="margin-top: 15px">
      审批记录
    </div>

    <el-table
      :data="tableData"
      border
      height="180"
    >
      <el-table-column prop="approver" label="审批人" align="left" />
      <el-table-column prop="approvalOpinion" label="审批意见" align="left" />
      <el-table-column prop="approvalTime" label="审批时间" align="left" />
    </el-table>

    <el-form :model="formData" label-width="80px" class="form-wrap">
      <el-form-item prop="transferOpinion" label="请审批意见">
        <el-input
          v-model="formData.transferOpinion"
          :autosize="{ minRows: 4, maxRows: 6}"
          type="textarea"
          placeholder="请输入审批意见"
          maxlength="200"
          show-word-limit
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="mini" @click="submitData('驳回')">
        驳回
      </el-button>
      <el-button type="primary" size="mini" @click="submitData('同意')">
        同意
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRefundApplyInfo, transactTelApplyRefund } from '@/API';

export default {
  data () {
    return {
      isShow: false,
      baseData: {},
      tableData: [],
      formData: { approvalId: '', transferOpinion: '' }
    };
  },

  methods: {
    openDialog ({ telApprovalId }) {
      this.formData.approvalId = telApprovalId;
      this.isShow = true;
      this.queryData(telApprovalId);
    },

    closeDialog () {
      this.isShow = false;
      this.baseData = {};
      this.tableData = [];
      this.formData = { approvalId: '', transferOpinion: '' };
    },

    queryData (id) {
      getRefundApplyInfo({ telApprovalId: id }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.baseData = data;
          this.tableData = data.approvalRecords || [];
        }
      });
    },

    submitData (type) {
      if (type === '驳回' && !this.formData.transferOpinion) {
        return this.$message.warning('请输入审批意见！');
      }
      this.isLoading = true;
      let params = {
        type,
        ...this.formData
      };
      transactTelApplyRefund(params)
        .then((res) => {
          this.isLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.closeDialog();
            this.$emit('on-ok', data);
          }
        }).catch(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.form-wrap{
  margin-top: 14px;
}
</style>
